export interface UserTagPresentation {
  key: string;
  label: string;
}

const USER_TAGS = new Map<string, UserTagPresentation>([
  ["user", { key: "user", label: "Farmer/Customer" }],
  ["farmer", { key: "farmer", label: "Farmer/Customer" }],
  ["member", { key: "member", label: "Member" }],
  ["not member", { key: "not-member", label: "Not Member" }],
  ["agent", { key: "agent", label: "Agent" }],
  ["admin", { key: "admin", label: "Admin" }],
  [
    "agronomist_agent",
    { key: "agronomist_agent", label: "Agronomist Agent" },
  ],
  [
    "agronomist_admin",
    { key: "agronomist_admin", label: "Agronomist Admin" },
  ],
  ["dairy", { key: "dairy", label: "Dairy" }],
]);

export function matchesAccountRole(accountRole: string, filter: string): boolean {
  if (filter === "all") return true;
  if (filter === "farmer") return ["farmer", "user"].includes(accountRole);
  return accountRole === filter;
}

export function getUserTagPresentation(
  value: unknown,
): UserTagPresentation | null {
  if (typeof value !== "string" || !value.trim()) {
    return null;
  }

  return USER_TAGS.get(value.trim().toLowerCase()) || null;
}
